module.exports = __webpack_public_path__ + "img/antes_despues_274.034b0cd1.png";